import { Component, Input, OnInit } from '@angular/core';
import { User } from '@app/models/user.model';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-login-shortcut-banner',
  templateUrl: './login-shortcut-banner.component.html',
  styleUrls: ['./login-shortcut-banner.component.scss'],
  standalone: false,
})
export class LoginShortcutBannerComponent implements OnInit {
  environment: any = environment; // Need this for template to provide base url to an external link (ex. docebo user profile)
  @Input() user: User;

  constructor() {}

  ngOnInit(): void {
    this.environment = environment;
  }
}
